import { render } from "./ClientsRankingLastAttendant.vue?vue&type=template&id=54b0b9c4&ts=true"
import script from "./ClientsRankingLastAttendant.vue?vue&type=script&lang=ts"
export * from "./ClientsRankingLastAttendant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__